// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"7c19240c","464":"15fc7935"}[chunkId] + ".chunk.js";
};